<template>
  <div>
    <!-- <h2
      class="text-565656 fsize16 font-semibold border-b pb-4 flex items-center"
    >
      Add-ons
      <div
        v-tooltip.top="{
          content: 'Cloud resources, email IDs, sender IDs and more.',
          class: 'toolcust',
        }"
      >
        <feather-icon
          icon="InfoIcon"
          class="ml-1 text-grey flex ml-1 cursor-pointer"
          svgClasses="w-5 h-5"
        />
      </div>
    </h2> -->
    <div class="grid gap-4 grid-cols-3">
      <div
        class="cursor-pointer"
        v-for="(item, index) in myAddons"
        :key="'item -' + index"
        @click="handleClick(item.route)"
      >
        <div class="flex items-center bg-lightf4f5f6 border-round p-3">
          <div class="flex gap-4 items-center w-10/12">
            <img
              :src="item.image"
              class="object-contain ecom-cardw"
              alt="banh"
            />

            <div class="w-full">
              <h3 class="col-4f fsize14 font-medium mb-0">
                {{ item.title }}
              </h3>
            </div>
          </div>
          <div class="w-2/12 flex justify-end cursor-pointer">
            <img src="@/assets/images/aright.png" class="w-35px rounded-full" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      myAddons: [
        {
          id: "01",
          title: "My Request",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Ecom/ecom.svg",
          route: "Add-ons-myrequest",
        },

        {
          id: "02",

          title: "My Add-ons",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Ecom/ecom1.svg",
          route: "Add-ons-myaddons",
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
